import React from 'react';
import noop from 'lodash/noop';

export default React.createContext({ trigger: noop, close: noop });
